export default __webpack_public_path__ + "static/media/slowbotton.456bd192.png";